"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeNames_1 = require("../enum/NodeNames");

var Params_1 = require("../utils/Params");

var AbstractNode_1 = require("./abstract/AbstractNode");

var SwitchCaseNode_1 = require("./SwitchCaseNode");

var SwitchDefaultNode_1 = require("./SwitchDefaultNode");

var SwitchNode =
/*#__PURE__*/
function (_AbstractNode_1$defau) {
  _inherits(SwitchNode, _AbstractNode_1$defau);

  _createClass(SwitchNode, [{
    key: "hasBody",
    get: function get() {
      return true;
    }
  }]);

  function SwitchNode(token) {
    var _this;

    _classCallCheck(this, SwitchNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SwitchNode).call(this, NodeNames_1.default.Switch, token));
    _this.params = Params_1.paramParser(token.start, token.end, token.params);
    _this.cases = [];
    return _this;
  }

  _createClass(SwitchNode, [{
    key: "addToNode",
    value: function addToNode(child) {
      if (child instanceof SwitchCaseNode_1.default || child instanceof SwitchDefaultNode_1.default) {
        this.cases.push(child);
      } else if (this.cases.length === 0) {
        if (child.type === NodeNames_1.default.Text) {
          return;
        }
      } else {
        this.cases[this.cases.length - 1].consequent.push(child);
        return;
      }

      _get(_getPrototypeOf(SwitchNode.prototype), "addToNode", this).call(this, child);
    }
  }]);

  return SwitchNode;
}(AbstractNode_1.default);

exports.default = SwitchNode;